/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class FreshserviceSecurityAlertMapping extends models.FreshserviceMappingBase {
    getFixupPrototypeFunction() { return FreshserviceSecurityAlertMapping.fixupPrototype; }

    static newInstance(model: Partial<FreshserviceSecurityAlertMapping>): FreshserviceSecurityAlertMapping {
        let obj = Object.assign(new FreshserviceSecurityAlertMapping(), model);
        FreshserviceSecurityAlertMapping.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<FreshserviceSecurityAlertMapping>): FreshserviceSecurityAlertMapping {
        if (!model) return null;
        return FreshserviceSecurityAlertMapping.newInstance(<FreshserviceSecurityAlertMapping> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: FreshserviceSecurityAlertMapping) {
        if (!obj) return;

        models.FreshserviceSecurityAlertMapping.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: FreshserviceSecurityAlertMapping): boolean {
        if (models.FreshserviceMappingBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, FreshserviceSecurityAlertMapping.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.attribute_mappings) {
            for (let val of this.attribute_mappings) {
                models.FreshserviceIncidentConfigurationMappingForSecurityAlert.fixupPrototype(val);
            }
        }
    }

    /**
     * List of Security Alert attribute enums for Freshservice
     */
    description_attributes: Array<models.DescriptionAttributeForItsmSecurityAlert>;

    /**
     * List of Freshservice attribute mappings
     */
    attribute_mappings: Array<models.FreshserviceIncidentConfigurationMappingForSecurityAlert>;

}
